import { CityRO } from '@routellers/types/dist/city/city.ro';

import { ApiMethodDeclaration } from '..';

type ParamsData = number;

type ResponseData = CityRO;

export const getOne: ApiMethodDeclaration<ParamsData, ResponseData> = (id) => ({
    url: `/cities/${id}`,
    method: 'GET',
});
